export default __webpack_public_path__ + "static/media/v1_team_bg.6c965b8e.png";